export default function MarketingData() {
    return [
        {
            text: [
                {
                    title: "Purchasing term insurance has never been easier",
                    paragraphs: ["After receiving a quote you will have the option to proceed online or work with our team of insurance experts to finalize your purchase."],
                }
            ],
            image: "/product-landing/term/circle2.png"
        },
        {
            text: [
                {
                    title: "Compare features that matter most",
                    paragraphs: ["In addition to a simplified quoting process, we'll provide you with buying choices from top rated insurance companies, offering the most options, fastest approvals and the lowest prices."],
                }
            ],
            image: "/product-landing/term/circle3.png"
        },
        {
            text: [
                {
                    title: "We're here to support you every step of the way",
                    paragraphs: ["Our licensed concierge team is available to answer any questions you may have throughout your purchase journey."],
                }
            ],
            image: "/product-landing/term/circle4.png"
        }
    ]
}